import { Box, styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { LmsType } from '../components/classroom/types';
import MainLayout from '../components/layout/MainLayout';
import { getUrlParams } from '../utils/url';

const StyledMainDiv = styled(Box)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const StyledTextDiv = styled(Box)`
    flex: 1;
    padding-top: 40px;
    padding-bottom: 12px;
`;

export const getLmsName = (t, lmsType) => {
    switch (lmsType) {
        case LmsType.Blackboard:
            return 'Learn';
        case LmsType.Canvas:
            return 'Canvas';
        case LmsType.D2l:
            return 'Brightspace';
        case LmsType.Moodle:
            return 'Moodle';
        case LmsType.OpenLms:
            return 'OpenLMS';
        case LmsType.Schoology:
            return 'Schoology';
        case LmsType.Docebo:
            return 'Docebo';
        case LmsType.IMS:
            return 'IMS';
        default:
            return t('lms-auth-default-lms-name');
    }
};

export const LmsAuthSuccess = () => {
    const { ready, t } = useTranslation('lms_sync');
    const { lms_type: lmsType } = getUrlParams();

    if (ready) {
        return (
            <MainLayout title={t('lms-auth-title')}>
                <StyledMainDiv>
                    <StyledTextDiv>
                        <Typography variant="h3" data-testid="authResult">
                            {t('lms-auth-success')}
                        </Typography>
                    </StyledTextDiv>
                    <Typography>{t('lms-auth-directions', { lmsName: getLmsName(t, lmsType) })}</Typography>
                </StyledMainDiv>
            </MainLayout>
        );
    }

    return null;
};

export default LmsAuthSuccess;
